import { Variants } from 'framer-motion';

/**
 * Shared motion variants. Framer Motion respects `prefers-reduced-motion`
 * automatically when using the `useReducedMotion` hook — components that
 * need per-instance control should call that hook and pass `false`
 * durations/distances accordingly. These variants keep distances modest by
 * default so even without that hook the motion stays subtle.
 */

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } },
};

export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.05,
    },
  },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

export const viewportOnce = { once: true, margin: '-80px' };
